import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { WalletProvider } from './contexts/WalletContext'
import { AccessProvider } from './contexts/AccessContext'
import { UserDataProvider } from './contexts/UserDataContext'
import { Toaster } from 'sonner'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WalletProvider>
      <AccessProvider>
        <UserDataProvider>
          <App />
          <Toaster
            position="top-right"
            theme="dark"
            closeButton
            toastOptions={{
              duration: 5000,
              style: {
                background: '#0e0f10',
                border: '1px solid #2d3748',
                color: '#fff',
                fontSize: '13px',
                fontFamily: 'ui-monospace, SFMono-Regular, SF Mono, Menlo, monospace',
              },
              classNames: {
                toast: 'group toast',
                closeButton: '!bg-transparent !border-none !text-[#6c7884] hover:!text-white !right-2 !top-2',
                error: '!border-[#f6465d]',
                success: '!border-[#0ecb81]',
                title: '!text-[13px] !font-medium',
                description: '!text-[12px] !text-[#6c7884]',
              },
            }}
          />
        </UserDataProvider>
      </AccessProvider>
    </WalletProvider>
  </StrictMode>,
)
